import { Card, CardContent } from 'components/ui/card';
import { cn } from 'lib/utils';

export function UsageStatCard({
  label,
  value,
  subLabel,
  valueClassName,
}: {
  label: string;
  value: string;
  subLabel: string;
  valueClassName?: string;
}) {
  return (
    <Card className="min-w-0 overflow-hidden border-border/70 shadow-none">
      <CardContent className="min-w-0 space-y-2 p-4">
        <div className="text-xs font-medium text-muted-foreground">{label}</div>
        <div
          title={value}
          className={cn(
            'truncate font-mono text-xl font-medium tracking-tight text-foreground sm:text-2xl',
            valueClassName
          )}
        >
          {value}
        </div>
        <div className="text-xs text-muted-foreground">{subLabel}</div>
      </CardContent>
    </Card>
  );
}
